module.exports = __webpack_public_path__ + "static/media/truck_front_1.0d7704f0.png";